<template>
    <div>
        <self-back :pageHeaderList="[{'name':'角色管理'}]"></self-back>
        <div class="content" v-loading='loading'>
            <button class="addRoleButton" @click="addRoleEvent" v-if="userInfo.role_id == 12">+ 添加角色</button>
            <el-table
                class="table"
                :header-cell-style="{background:'#f5f7fa'}"
                :data="roleList"
                :max-height="tableMaxHeight"
                border
                >
                <el-table-column
                prop="name"
                label="角色名称"
                align='center'
                width="200"
                >
                </el-table-column>
                <el-table-column
                prop="desc"
                align='center'
                label="角色描述"
                >
                </el-table-column>
                <el-table-column
                align='center'
                label="操作">
                    <template slot-scope="scope">
                        <button @click="modifyRoleEvent(scope.row)" v-if="scope.row.id != 1">修改</button>
                        <button style="background:#FF9B3B" @click="assignPermissions(scope.row.id)">分配权限</button>
                        <!-- <button style="background:#FC726D" @click="deleteRoleFlagEvent(scope.row)">删除</button> -->
                    </template>
                </el-table-column>
            </el-table>
            <div class="paginationBox">
                <el-pagination
                    small
                    background
                    :current-page="page"
                    @current-change="handleCurrentChange"
                    :page-size="page_size"
                    layout="total, prev, pager, next"
                    :total="total">
                </el-pagination>
            </div>
        </div>
        <!-- 添加角色 -->
        <el-dialog
            :title="isEdit?'修改角色':'添加角色'"
            :visible.sync="addRoleFlag"
            width="30%"
            :close-on-click-modal='false'
            center>
            <div class="dialogBox">
                <div class="dialogitem" style="margin-bottom: 20px;">
                    <label>角色名称：</label>
                    <el-input
                        placeholder="请输入角色名称"
                        style="width:76%"
                        v-model.trim="roleName"
                        size='small'
                        clearable>
                    </el-input>
                </div>
                <div class="dialogitem">
                    <label>角色描述：</label>
                    <el-input
                        placeholder="请输入角色描述"
                        style="width:76%"
                        v-model.trim="roleDesc"
                        size='small'
                        clearable>
                    </el-input>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="cancelAddRole" size="mini">取 消</el-button>
                <el-button type="primary" @click="addRoleYes" size="mini">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
export default {
    data(){
        return{
            addRoleFlag:false,
            roleList:[],
            roleName:'',
            roleDesc:'',
            page:1,
            page_size:20,
            total:0,
            loading:false,
            roleId:'',
            isEdit:false,
            userInfo:{}
        }
    },
    computed: {
        // 计算表格最大高度，确保分页控件和Footer可见
        tableMaxHeight() {
            // Header(60) + self-back(50) + padding(30) + button(30) + button-margin(15) + table-margin(15) + pagination(40) + pagination-margin(15) + footer(70) + footer-margin(10) = 335px
            // 留一些余量，使用 380px
            return window.innerHeight - 280;
        }
    },
    created(){
        this.userInfo = JSON.parse(this.$cookie.getCookie('userInfo'));
        this.rolesListEvent(1)
    },
    methods:{
        assignPermissions(id){
            this.$router.push({path:'/permissionBigClass/'+id})
        },
        addRoleEvent(){//点击添加角色按钮
            this.addRoleFlag = true;
            this.isEdit = false;
        },
        deleteRoleFlagEvent(data){//删除角色
            this.$confirm('确定要删除该角色?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
                }).then(() => {
                    this.$axios.post(this.URL.BASEURL + this.URL.delRole,{
                        id: data.id
                    }).then((res) => {
                        var res=res.data;
                        if(res&& res.errno == 0){
                            this.rolesListEvent(this.page)
                        }else {
                            this.$message({
                                message: res.err,
                                type: 'warning'
                            })
                        }
                    }).catch(()=>{
                    })
                }).catch(() => {        
            });
        },
        handleCurrentChange(val){
            this.rolesListEvent(val)
        },
        rolesListEvent(page){
           this.loading = true;
           this.page = page
           this.$axios.get(this.URL.BASEURL + this.URL.rolesList,{
               params:{
                   page: page,
                   page_size: this.page_size
               }
            }).then((res) => {
                var res=res.data;
                this.loading = false;
                if(res&& res.errno == 0){
                    var arr = res.rst.data;
                    if(this.userInfo.role_id != 12){
                        this.roleList = arr.filter((v)=>{
                            return v.id != 12
                        })
                    }else{
                        this.roleList = arr;
                    }
                    this.total = res.rst.pageInfo.total;
                }else {
                    this.$message({
                        message: res.err,
                        type: 'warning'
                    })
                }
            }).catch(()=>{
                this.loading = false
            })
        },
        addRoleYes(){//添加角色
            if(this.roleName == ''){
                this.$message({
                    message: '请输入角色名称',
                    type: 'fail'
                })
                return
            }
            if(this.isEdit){//编辑
                this.$axios.post(this.URL.BASEURL + this.URL.editRole,{
                    name: this.roleName,
                    desc: this.roleDesc,
                    id: this.roleId
                }).then((res) => {
                    var res=res.data;
                    if(res&& res.errno == 0){
                        this.rolesListEvent(this.page)
                        this.cancelAddRole()
                    }else {
                        this.$message({
                            message: res.err,
                            type: 'warning'
                        })
                    }
                }).catch(()=>{
                })
            }else{
                this.$axios.post(this.URL.BASEURL + this.URL.addRole,{
                    name: this.roleName,
                    desc: this.roleDesc,
                }).then((res) => {
                    var res=res.data;
                    if(res&& res.errno == 0){
                        this.rolesListEvent(this.page)
                        this.cancelAddRole()
                    }else {
                        this.$message({
                            message: res.err,
                            type: 'warning'
                        })
                    }
                }).catch(()=>{
                })
            }
        },
        cancelAddRole(){//取消添加角色
            this.addRoleFlag = false;
            this.roleName = '';
            this.roleDesc = '';
        },
        modifyRoleEvent(data){//修改角色
            this.roleName = data.name;
            this.roleDesc = data.desc;
            this.roleId = data.id;
            this.isEdit = true;
            this.addRoleFlag = true;
        }
    },
    watch:{
    }
}
</script>
<style lang="scss" scoped>
.content{
    width: 100%;
    background: #FFFFFF;
    box-shadow: 0px 2px 6px 0px rgba(32, 38, 82, 0.1);
    padding: 15px 15px 15px;
    min-height: calc(100vh - 140px); // 确保内容区域有最小高度
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    .addRoleButton{
        width: 100px;
        height: 30px;
        background: #5B7BFE;
        border-radius: 4px;
        color: #FFFFFF;
        font-size: 13px;
        border:none;
        flex-shrink: 0;
    }
    .table{
        margin-top: 15px;
        flex: 1;
        min-height: 0;
        button{
            min-width: 60px;
            height: 26px;
            background: #5B7BFE;
            border-radius: 4px;
            color: #FFFFFF;
            font-size: 12px;
            border: none;
            padding: 0 6px;
        }
    }
    .paginationBox{
        flex-shrink: 0;
        margin-top: 15px;
        padding-bottom: 0;
    }
}
.dialogitem{
    margin-bottom: 20px;
    &:last-of-type{
        margin-bottom: 0;
    }
    label{
        display: inline-block;
        width: 80px;
        color: #202652;
        font-size: 14px;
        line-height: 20px;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/systemManage/roleManage.vue